<template>
  <div class="container">
    <div class="header-image-wrapper">
      <h1>Support plans that grow with your startup</h1>
    </div>
    <!-- <p>All plans are no long term commitment month to month plans.</p>
    <p>
      Get access to our support teams to ensure your system is up and
      functioning consistently. Submit support request and use our tools to
      track progress.
    </p> -->

    <v-row>
      <v-col cols="12" class="what-does-it-cost">
        <!-- <div class="display-1 mt-5">
          Choose a Support team plan that works for you
        </div> -->
        <v-row class="mt-5">
          <v-col cols="12">
            <v-row class="justify-center">
              <!-- <v-col cols="12" md="4">
                <v-card
                  class="mx-auto pa-3"
                  max-width="450"
                  min-height="420"
                  outlined
                >
                  <h2 class="text-center font-weight-bold mb-2">
                    Idea
                  </h2>
                  <div class="title text-center mb-2">
                    $0/month
                  </div>

                  <div class="px-5">
                    <ul>
                      <li>
                        Mentorship Support: Access to our Q & A mentor team
                        chat.
                      </li>
                      <li>
                        Tools: 1 user login to our startup planning and tracking
                        tools.
                      </li>
                      <li>
                        Development Teams : submit feature requests and get
                        quotes from the Hive Development Teams.
                      </li>
                    </ul>
                  </div>
                </v-card>
              </v-col> -->

              <v-col cols="12" md="4">
                <v-card
                  class="mx-auto pa-3"
                  max-width="450"
                  min-height="420"
                  outlined
                >
                  <h2 class="text-center font-weight-bold mb-2">
                    Solopreneur
                  </h2>
                  <div class="title text-center mb-3">
                    <!-- <span class="cross-out">$50/month </span>
                    <span class="ml-2 text-red"> Free for 3 months </span> -->
                    <span class="ml-2"> $0/month </span>
                  </div>

                  <div class="px-5">
                    <ul>
                      <li>
                        Support Teams :
                        <ul>
                          <li>
                            Submit feature requests and get quotes from the Hive
                            Support Teams.
                          </li>
                        </ul>
                      </li>
                      <li>
                        Tools:
                        <ul>
                          <li>
                            1 user login to our startup support planning and
                            tracking tools.
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card
                  class="mx-auto pa-3"
                  max-width="450"
                  min-height="420"
                  outlined
                >
                  <h2 class="text-center font-weight-bold mb-2">
                    Traction
                  </h2>
                  <div class="title text-center mb-3">$500/month</div>

                  <p class="text-center">All 'Solopreneur' features, Plus:</p>
                  <div class="px-5">
                    <ul>
                      <li>
                        Hive Support Team:
                        <ul>
                          <li>
                            Get 5 free minor and 1 major code support incidents
                            per month.
                          </li>
                        </ul>
                      </li>
                      <li>
                        Tools:
                        <ul>
                          <li>
                            5 user logins to our support planning and tracking
                            tools.
                          </li>
                          <li>Access to team features.</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card
                  class="mx-auto pa-3"
                  max-width="450"
                  min-height="420"
                  outlined
                >
                  <h2 class="text-center font-weight-bold mb-2">
                    Growth
                  </h2>
                  <div class="title text-center mb-3">$1500/month</div>

                  <p class="text-center">
                    All 'Traction' features, Plus:
                  </p>
                  <div class="px-5">
                    <ul>
                      <li>
                        Hive Support Team:
                        <ul>
                          <li>
                            Get 10 free minor minor and 5 major code support
                            incidents per month.
                          </li>
                          <li>
                            support team will support and perform upgrades to
                            your servers.
                          </li>
                        </ul>
                      </li>
                      <li>
                        Tools:
                        <ul>
                          <li>
                            10 user logins to our support planning and tracking
                            tools.
                          </li>
                          <li>Access to team features.</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card
                  class="mx-auto  pa-3"
                  max-width="450"
                  min-height="420"
                  outlined
                >
                  <h2 class="text-center font-weight-bold mb-2">
                    Scale
                  </h2>
                  <div class="text-center request-chat-wrapper">
                    <div
                      class="upscribe-embed request-chat-sm"
                      data-src="https://upscri.be/thia32"
                    ></div>
                  </div>
                  <p class="text-center">All 'Growth' features, Plus:</p>
                  <div class="px-5">
                    <ul>
                      <li>
                        Hive Support Team:
                        <ul>
                          <li>Get unlimited code support.</li>
                          <li>
                            Support for your servers with a Five Nines uptime
                            SLA.
                          </li>
                        </ul>
                      </li>
                      <li>
                        Tools:
                        <ul>
                          <li>
                            Unlimited logins to our startup team planning and
                            tracking tools.
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<style lang="scss" scoped>
.cross-out {
  text-decoration: line-through;
}
.text-red {
  color: red;
}
.header-image-wrapper {
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url(/img/support-bg.jpg) no-repeat center center;
  height: 400px;
  text-align: center;
  position: relative;
  h1 {
    color: white;
    font-size: 3.3rem;
    // margin: 55px auto;
    padding-top: 150px;
  }
}
</style>
<script>
export default {};
</script>
